import {apiService} from '../services/ApiService';
import {useQuery} from 'react-query';

function useUserPermissions() {

    const fetchDataUser = async () => {
        try {
            const response = await apiService.getMeRole();

            return response.data.capabilities;
        } catch (error) {
            console.error('Failed to fetch user permissions data:', error);
            throw error;
        }
    };

    return useQuery({
        queryKey: ['me-permissions'],
        queryFn: fetchDataUser,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}

export default useUserPermissions;
